<template>
  <nav class="estat-nav" aria-label="Main navigation">
    <Link v-for="item in items" :key="item.url" :href="item.url" class="estat-nav-link" :class="{ active: isActive(item.url) }" :aria-current="isActive(item.url) ? 'page' : undefined">
      <span class="estat-nav-icon" :style="{ color: item.color }"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" aria-hidden="true"><path :d="item.path" stroke-linecap="round" stroke-linejoin="round" /></svg></span><span>{{ item.label }}</span>
    </Link>
  </nav>
</template>
<script>
import { Link } from '@inertiajs/inertia-vue3'
export default {
  components: { Link },
  props: { auth: Object },
  computed: {
    items() {
      const user = (this.auth || this.$page.props.auth || {}).user || {}
      const can = permission => (user.permissions || []).includes(permission)
      return [
        { url: can('reports.view') ? '/' : (user.has_assignments && !user.can_manage_representatives ? '/representative/licenses' : '/owner/dashboard'), label: 'Home', color: '#006483', path: 'M3 10l9-7 9 7v11h-6v-7H9v7H3z' },
        ...(can('licenses.view') ? [{ url: '/licenses', label: 'Licenses', color: '#008aab', path: 'M6 3h9l4 4v14H5V3h1zm8 0v5h5M8 12h8M8 16h6' }] : []),
        { url: '/energy-reports', label: 'Energy Reports', color: '#006483', path: 'M4 3h16v18H4zM8 16v-3m4 3V8m4 8v-5' },
        ...(user.can_manage_representatives ? [{ url: '/owner/representatives', label: 'Manage Representatives', color: '#008aab', path: 'M16 7a4 4 0 11-8 0 4 4 0 018 0zM4 21v-2a8 8 0 0116 0v2M20 3v6m-3-3h6' }] : []),
        ...(user.has_assignments ? [{ url: '/representative/licenses', label: 'Assigned Licenses', color: '#008aab', path: 'M5 3h14v18H5zM8 8h8M8 12h8M8 16h5' }] : []),
        ...(can('admin.manage') ? [{ url: '/administration', label: 'Administration', color: '#006483', path: 'M12 3l8 4v5c0 5-8 9-8 9s-8-4-8-9V7zM9 12l2 2 4-4' }] : []),
        ...[{ url: can('legacy.access') ? '/profile' : '/owner/profile', label: 'Profile', color: '#36b8cf', path: 'M16 7a4 4 0 11-8 0 4 4 0 018 0zM4 21v-2a8 8 0 0116 0v2' }],
        ...[{ url: '/user-manual', label: 'User Manual', color: '#f5365c', path: 'M12 5C8 2 3 3 3 3v16s5-1 9 2c4-3 9-2 9-2V3s-5-1-9 2zm0 0v16' }],
      ]
    },
  },
  methods: { isActive(url) { const path = this.$page.url.split('?')[0]; return url === '/' ? path === '/' : path === url || path.startsWith(url + '/') } },
}
</script>